import { RESCUES, RESCUES_PAGINATE, RESCUES_PARAMS, RESCUES_QUERY } from '@store/types'
import shortly from 'vuex-shortly'
import graphQL from '@graphQL'
import RescueQuery from '@graphQL/queries/Rescues'

const state = {
  list: [],
  details: {},
  paginate: {},
  params: {
    search: ''
  }
}

const getters = {
  [RESCUES]: 'list',
  [RESCUES_PAGINATE]: 'paginate',
  [RESCUES_PARAMS]: 'params'
}

const mutations = {
  [RESCUES]: 'list',
  [RESCUES_PAGINATE]: 'paginate',
  [RESCUES_QUERY]: (state, payload) => {
    state.params.search = payload
  }
}

const actions = {
  [RESCUES]: async ({ commit }, payload = {}) => {
    if (payload.period) {
      payload.end_date = payload.period.end
      payload.start_date = payload.period.start
    }
    const response = await graphQL(RescueQuery, payload)
    const { data: rescues, ...paginate } = response?.data?.data?.rescues || {}
    commit(RESCUES, rescues)
    commit(RESCUES_PAGINATE, paginate)
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/rescues.js